import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { compact } from 'lodash';
import { DealFinderState } from '@model/state';
import { getDealFinderAvailableAirports, getDealFinderState } from '@state/slices/deal-finder/dealFinderSelectors';
import { setAirports } from '@state/slices/deal-finder/dealFinderSlice';
import { Airports } from './Airports';
import { getAlgoliaStateAirports, getAlgoliaTourAirportsByType } from '@state/slices/algolia/algoliaSelectors';
import { setAirportsQuery } from '@state/slices/algolia/algoliaSlice';
import { TripTypes } from '@model/common/tours/trip-types';
import { AirportResult } from '@model/search';
import { dispatch } from '@state/store';

export interface AirportsContainerProps {
  tabsRef: any;
  isError?: boolean;
  isCondensed: boolean;
  onChange?: (airports: Array<string>) => void;
  onClear?: () => void;
  airports?: Array<string>;
  available?: Array<string>;
  isNotGroupResults?: boolean;
  placeholderKey?: string;
  tripType?: TripTypes;
  isVisible?: boolean;
}

export const AirportsContainer = ({
  tabsRef,
  isError = false,
  isCondensed,
  onChange,
  onClear,
  airports,
  available,
  isNotGroupResults,
  placeholderKey,
  tripType,
  isVisible
}: AirportsContainerProps) => {
  const dealFinder: DealFinderState = useSelector(getDealFinderState);
  const algoliaAirports: Array<AirportResult> = useSelector(
    tripType ? getAlgoliaTourAirportsByType(tripType) : getAlgoliaStateAirports
  );
  const availableAirports: Array<string> = useSelector(getDealFinderAvailableAirports);
  const values =
    airports && (!airports.length || !!algoliaAirports.find(({ airport: { code } }) => airports?.includes(code)))
      ? compact(airports)
      : dealFinder.airports;

  useEffect(() => {
    if (isVisible) {
      dispatch(setAirportsQuery({ query: '' }));
    }
  }, [isVisible]);

  const handleOnChange = (payload: Array<string>) => {
    if (onChange) {
      onChange(payload);
    } else {
      dispatch(setAirports(payload));
    }
  };

  const handleOnInputChange = (payload: string) => {
    if (isVisible !== false) {
      dispatch(setAirportsQuery({ query: payload }));
    }
  };

  return (
    <Airports
      values={values}
      isError={!!isError}
      onChange={handleOnChange}
      onClear={onClear}
      options={algoliaAirports}
      onInputChange={handleOnInputChange}
      available={available || availableAirports}
      tabsRef={tabsRef}
      isCondensed={isCondensed}
      isNotGroupResults={isNotGroupResults}
      placeholderKey={placeholderKey}
    />
  );
};
